import { render, staticRenderFns } from "./SliderProduct.vue?vue&type=template&id=02b31899&scoped=true&"
import script from "./SliderProduct.vue?vue&type=script&lang=js&"
export * from "./SliderProduct.vue?vue&type=script&lang=js&"
import style0 from "./SliderProduct.vue?vue&type=style&index=0&id=02b31899&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b31899",
  null
  
)

export default component.exports